import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseApplicationsAndUrls from '../../AbstractObjects/GatewayPlan/InnerPages/BaseApplicationsAndUrls';

const pageSchema = PlanGetSchema.pages.applicationsAndUrls;
const pageId = pageSchema.pageId;

function PlanApplicationsAndUrls({
                                     planObject,
                                     setPlanData,
                                     setAppiDataValue
                                 }) {
    const pageData = planObject[pageId];

    return (
        <BaseApplicationsAndUrls
            pageData={pageData}
            setObjectData={setPlanData}
            setAppiDataValue={setAppiDataValue}
        />
    );
}

export default PlanApplicationsAndUrls;